import { USER } from '@/constants';
import { HTTP } from '@/http-common';
import { defineStore } from 'pinia';

export const useBravoStore = defineStore('bravo', {
    state: () => ({
        plans: []
    }),
    getters: {
        getPlans: (state) => state.plans
    },
    actions: {
        async getRedirectUrl(planId) {
            const user = JSON.parse(localStorage.getItem(USER));
            if (!user) {
                throw new Error('User is not authenticated');
            }
            const userId = user.id;
            return new Promise((resolve, reject) => {
                HTTP.post('/yallapay/subscription/web-checkout', { 
                    userId: userId, 
                    plan_uuid: planId
                 }).then((response) => {
                   
                    resolve(response);
                }).catch((error) => {
                    console.error('Error getting Bravo redirect URL:', error);
                    reject(error);
                }
                );
            });
        },
        async fetchPlans() {
           return new Promise((resolve, reject) => {
            HTTP.get('/bravo/plans/portal').then((response) => {
                this.plans = response.data;
                resolve(response.data);
            }).catch((error) => {
                console.error('Error fetching Bravo plans:', error);
                reject(error);
            });
           });
        }
    },
});
